import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { loginWithLambda } from '../repository/authRepository';
import { setupAutoRefresh } from '../utils/tokenRefresh';

export const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || '/home';

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setIsLoading(true);

    const response = await loginWithLambda({ username, password });

    if ('error' in response) {
      setError(response.error);
    } else {
      localStorage.setItem('access_token', response.access);
      localStorage.setItem('refresh_token', response.refresh);
      localStorage.setItem('user', JSON.stringify(response.user));
      setupAutoRefresh();
      navigate(from, { replace: true });
    }

    setIsLoading(false);
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="auth-title">Welcome back</h1>
        <p className="helper-text">Log in to manage your reading queue.</p>

        {error && <div className="alert error">{error}</div>}

        <form onSubmit={handleSubmit} className="grid" style={{ gap: '1rem' }}>
          <label className="field">
            <span className="field-label">Username</span>
            <input
              className="input"
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <label className="field">
            <span className="field-label">Password</span>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              disabled={isLoading}
            />
          </label>

          <button className="button" type="submit" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Log in'}
          </button>
        </form>

        <div className="helper-text" style={{ marginTop: '1rem' }}>
          <Link to="/signup">Create an account</Link> · <Link to="/password-reset">Forgot password?</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
